import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative expanded"
}
const _hoisted_2 = { class: "w-full mx-auto pt-2" }
const _hoisted_3 = {
  key: 1,
  class: "w-full flex pb-4 pt-1 mt-1 mb-1"
}
const _hoisted_4 = { class: "content-end" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex items-center ml-6 py-1.5" }
const _hoisted_7 = { class: "w-full h-min sm:h-48 sm:h-min" }
const _hoisted_8 = { class: "flex relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "overflow-hidden flex w-full h-auto lg:flex-nowrap flex-wrap" }
const _hoisted_11 = { class: "w-full mx-auto pt-2" }
const _hoisted_12 = { class: "content-end" }

import { ref, onMounted, onUnmounted } from 'vue';
// import { usePlayApiStore } from "../store/api/playApi";
// import { useRealtimeApiStore } from "../store/api/realtimeApi";
import { TempData, VenueData } from '@/models/queryBuilder'
import { CountryEnum } from '@/models/vscoreModels'

import { useConfirm } from "primevue/useconfirm";
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import Details from '../components/InformationCard.vue'
import Table from '../components/DataTable.vue';
import DataTabs from '../components/DataTabs.vue';
import EditInfo from '../components/EditInformationCard.vue';

// const playApi = usePlayApiStore()
// const api = useRealtimeApiStore()


export default /*#__PURE__*/_defineComponent({
  __name: 'VenueManager',
  props: ['selectedVenue', 'limit'],
  emits: ['return', 'changeEditStatus', 'setTableSize'],
  setup(__props, { emit: __emit }) {

const confirm = useConfirm();
const props = __props
const emit = __emit

const state = ref({
    isLoading: true,
    isEditMode: false,
    isNewVenue: (Object.keys(props.selectedVenue).length == 0),
})

const venueColumns = [
    [
        { name: 'Camera', key: 'camera' },
        { name: 'Position', key: 'position' },
        { name: 'N-Range', key: 'n_range' },
        { name: 'S-Range', key: 's_range' },
    ],
    [
        { name: 'Name', key: 'name' },
        { name: 'Age', key: 'age' },
        { name: 'Captain', key: 'captain' },
        { name: 'Keeper', key: 'keeper' },
        { name: 'PR', key: 'pr' }
    ],
    [
        { name: 'Name', key: 'name' },
        { name: 'Age', key: 'age' },
        { name: 'Captain', key: 'captain' },
        { name: 'Keeper', key: 'keeper' },
        { name: 'PR', key: 'pr' }
    ],
    [
        { name: 'Name', key: 'name' },
        { name: 'Age', key: 'age' },
        { name: 'Captain', key: 'captain' },
        { name: 'Keeper', key: 'keeper' },
        { name: 'PR', key: 'pr' }
    ]
]

const displayColumns = [
    // { name: 'ID', key: 'id' },
    { name: 'Stadium Name', key: 'name' },
    { name: 'City', key: 'city' },
    { name: 'Region', key: 'region' },
    { name: 'Country', key: 'country' },
    { name: 'Capacity', key: 'capacity' },
    { name: 'Location Lat', key: 'location.latitude' },
    { name: 'Location Long', key: 'location.longitude' },
]

const tabHeaders = [
    "Camera Management",
    "Intrinsics",
    "Sensor",
    "Planning Information",
]

const tabHeadersShortened = [
    "Camera",
    "Intrinsics",
    "Sensor",
    "Planning",
]

const cameraManagmentData: VenueData[] = []
const intrinsicsData: TempData[] = []
const sensorData: TempData[] = []
const planningInformationData: TempData[] = []

const data = ref([cameraManagmentData, intrinsicsData, sensorData, planningInformationData])

const emptyInfo = {
    data: {
        "Stadium Name": { value: "", type: "text", required: true },
        "City": { value: "", type: "text", required: true },
        "Region": { value: "", type: "text", required: false },
        "Country": {
            value: "",
            type: "autoComplete",
            options: Object.values(CountryEnum).filter((item) => { return isNaN(Number(item)) }),
            required: true
        },
        "Capacity": { value: undefined, type: "inputNumber", required: false },
        "Location Lat": { value: undefined, type: "inputNumber", required: false },
        "Location Long": { value: undefined, type: "inputNumber", required: false },
        // Footprint - not supported yet
        // "Footprint SVG": {value: "", type: "textarea", required: false},
    },
}
let information = ref(JSON.parse(JSON.stringify(emptyInfo)))

const tableOffset = ref(0)
const editableInformation = ref(JSON.parse(JSON.stringify(information.value.data)))
const tableData = ref()
// const inputTable = ref()

const smallScreen = ref(false)
const warning = ref(false)

onMounted(async () => {
    state.value.isLoading = true
    information.value["image"] = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Cpath fill='%23243045' d='M3 7V3l4 2zm15 0V3l4 2zm-7-1V2l4 2zM9 21.875q-1.3-.125-2.55-.375t-2.238-.612t-1.6-.838T2 19v-9q0-.625.788-1.162t2.137-.95t3.175-.65T12 7t3.9.238t3.175.65t2.138.95T22 10v9q0 .575-.612 1.05t-1.6.838t-2.238.612t-2.55.375V17H9zM12 11q2.425 0 4.188-.288T19 10.05q0-.125-1.9-.587T12 9t-5.1.463t-1.9.587q1.05.375 2.812.663T12 11'/%3E%3C/svg%3E"

    if (!state.value.isNewVenue) {
        // TODO
        getVenueData()

        displayColumns.forEach((element: { name: string, key: string }) => {
            information.value.data[element.name].value = byString(props.selectedVenue, element.key)
        });
        // information.value["image"] = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Cpath fill='%23243045' d='M3 7V3l4 2zm15 0V3l4 2zm-7-1V2l4 2zM9 21.875q-1.3-.125-2.55-.375t-2.238-.612t-1.6-.838T2 19v-9q0-.625.788-1.162t2.137-.95t3.175-.65T12 7t3.9.238t3.175.65t2.138.95T22 10v9q0 .575-.612 1.05t-1.6.838t-2.238.612t-2.55.375V17H9zM12 11q2.425 0 4.188-.288T19 10.05q0-.125-1.9-.587T12 9t-5.1.463t-1.9.587q1.05.375 2.812.663T12 11'/%3E%3C/svg%3E"

        // const columnsDataTable = [
        //     { name: 'Name', key: 'name' },
        //     { name: 'Email', key: 'email' },
        //     { name: 'Phone Number', key: 'phone_number' },
        //     { name: 'Role', key: 'role' },
        // ]
        // information.value["tableInfo"] = {
        //     columns: columnsDataTable,
        //     data: [
        //         {
        //             name: "James Watson",
        //             email: "james.watson@email.com",
        //             phone_number: "+00000000",
        //             role: "Primary Cont.",
        //         },
        //         {
        //             name: "Maria",
        //             email: "maria@email.com",
        //             phone_number: "+00000000",
        //             role: "Groundskeeper",
        //         },
        //         {
        //             name: "Steve",
        //             email: "steve@email.com",
        //             phone_number: "+00000000",
        //             role: "Groundskeeper",
        //         },
        //     ]
        // }
        tableData.value = unWrapData()
        editableInformation.value = JSON.parse(JSON.stringify(information.value.data))
        // inputTable.value = getTableInfo()

        emit('setTableSize')
    } else {
        resetData()
        state.value.isEditMode = true
    }
    window.addEventListener("resize", setSmallScreen);
    setSmallScreen()
    state.value.isLoading = false
})

onUnmounted(async () => {
    window.removeEventListener('resize', setSmallScreen)
})

/**
 * Determine whether the screen is smaller than 640px
 */
function setSmallScreen() {
    var width = window.innerWidth
    smallScreen.value = width < 640 ? true : false
}

/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of data object prop
 */
function unWrapData() {
    let tempArray: any[] = []
    data.value.forEach((element: TempData[] | VenueData[]) => {
        tempArray.push(JSON.parse(JSON.stringify(element)))
    });
    return tempArray
}

/**
 * Remove reactivity from referenced object to ensure unedited state is perserved
 * @returns new copy of imformation.listData object prop
 */
// function getTableInfo() {
//     if (information.value.tableInfo) {
//         return JSON.parse(JSON.stringify(information.value.tableInfo.data))
//     }
// }

const confirmSave = () => {
    validate()
    if (!warning.value) {
        confirm.require({
            message: 'Confirm to save',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'Cancel',
            acceptLabel: 'Save',
            accept: () => {
                //save entry
                save()
                emit('changeEditStatus', false)
                state.value.isEditMode = false
                state.value.isNewVenue = false
            }
        });
    }
};

const confirmCancel = () => {
    confirm.require({
        message: 'Are you sure you want to leave? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            warning.value = false
            emit('changeEditStatus', false)
            state.value.isEditMode = false
            resetData()
            if (state.value.isNewVenue) {
                emit('return')
            }
        }
    });
};

function validate() {
    warning.value = false
    if (editableInformation.value["Stadium Name"].value == "") {
        warning.value = true
    }
    if (editableInformation.value["City"].value == "") {
        warning.value = true
    }
    if (editableInformation.value["Country"].value == "") {
        warning.value = true
    }
}

async function save() {
    data.value = JSON.parse(JSON.stringify(tableData.value))
    information.value.data = JSON.parse(JSON.stringify(editableInformation.value))

    // information.value.tableInfo.data = JSON.parse(JSON.stringify(inputTable.value))

    if (state.value.isNewVenue) {
        const newVenue: any = {
            name: editableInformation.value["Stadium Name"].value,
            city: editableInformation.value["City"].value,
            country: editableInformation.value["Country"].value,
        }
        if (editableInformation.value["Region"].value) newVenue["region"] = editableInformation.value["Region"].value
        if (editableInformation.value["Capacity"].value !== 0) newVenue["capacity"] = editableInformation.value["Capacity"].value
        if (editableInformation.value["Location Lat"].value && editableInformation.value["Location Long"].value)
            newVenue["location"] = {
                latitude: editableInformation.value["Location Lat"].value,
                longitude: editableInformation.value["Location Long"].value,
            }
        // API CALL
        // await api.createVenue(newVenue).then((response) => {
        //     state.value.isNewVenue = false
        //     console.log("location: " + response)
        // })
    }
}

/**
 * Remove changes made in edit mode
 */
function resetData() {
    editableInformation.value = JSON.parse(JSON.stringify(information.value.data))
    tableData.value = unWrapData()
    // inputTable.value = getTableInfo()
}

/**
 * Remove item from table
 * Item is only removed from entity when changes are saved
 * @param item to be removed from table
 */
function removeItem(item: any) {
    tableData.value.forEach(function (elementArray: [], indexArray: number) {
        elementArray.forEach(function (element: object, index: number) {
            if (element === item) {
                tableData.value[indexArray].splice(index, 1)
            }
        })
    });
}

/**
 * Remove item from info table
 * Item is only removed from entity when changes are saved
 * @param item to be removed from info table
 */
// function removeRowFromInfoTable(item: any) {
//     inputTable.value.forEach(function (element: object, index: number) {
//         if (element === item) {
//             inputTable.value.splice(index, 1)
//         }
//     })
// }

function getVenueData() {
    data.value[0] = [
        {
            camera: "N",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "S",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "NE",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "NW",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "SE",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "SW",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "NER",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "NWR",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
        {
            camera: "SER",
            position: "Decimal degrees",
            n_range: "Decimal degrees",
            s_range: "Decimal degrees",
        },
    ]

    data.value[1] = [
        {
            name: "Jameson",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "Jameson",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "Jameson",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
    ]

    data.value[2] = [
        {
            name: "Peter",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "Peter",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "Peter",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
    ]

    data.value[3] = [
        {
            name: "John",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "John",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
        {
            name: "John",
            age: "57",
            captain: true,
            keeper: false,
            pr: "Batter",
        },
    ]
}

function byString(o: { [x: string]: any; }, s: string) {
    const properties = s.split(".");
    for (let i = 0; i < properties.length; i++) {
        if (!o) return null;
        o = o[properties[i]];
    }
    return o;
}


return (_ctx: any,_cache: any) => {
  return (!state.value.isEditMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          icon: "pi pi-chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('return'); resetData();}),
          class: "absolute left-0 top-0 mt-1 pl-0 pr-4 w-max",
          "aria-label": "Bookmark"
        }),
        _createVNode(Details, {
          information: _unref(information),
          class: "py-2 pl-4 information"
        }, null, 8, ["information"]),
        _createVNode(DataTabs, {
          headers: smallScreen.value ? tabHeadersShortened : tabHeaders,
          expandedActive: 0,
          parentTabActive: 3,
          class: "mb-3 relative"
        }, {
          default: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_2, [
              (!state.value.isLoading)
                ? (_openBlock(), _createBlock(Table, {
                    key: 0,
                    "is-edit-mode": false,
                    data: data.value[slotProps.index].slice(tableOffset.value, tableOffset.value + __props.limit),
                    columns: venueColumns[slotProps.index],
                    onNextPage: _cache[1] || (_cache[1] = ($event: any) => (tableOffset.value = tableOffset.value + __props.limit)),
                    onPrevPage: _cache[2] || (_cache[2] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                    limit: __props.limit,
                    offset: tableOffset.value,
                    "total-count": data.value[slotProps.index].length
                  }, null, 8, ["data", "columns", "limit", "offset", "total-count"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_unref(ProgressSpinner), {
                      class: "justify-center w-90 h-90",
                      "attrs-color-black": "",
                      strokeWidth: "5",
                      animationDuration: "1s",
                      "aria-label": "Loading"
                    })
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["headers"]),
        _createElementVNode("div", _hoisted_4, [
          (!state.value.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = ($event: any) => {state.value.isEditMode = true; _ctx.$emit('changeEditStatus', true)}),
                class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
              }, " Edit "))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_unref(information).image !== undefined)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(information).image,
                    alt: "Image",
                    class: "w-28 h-20 sm:w-auto sm:h-48 self-center mr-8"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(EditInfo, {
                  information: editableInformation.value,
                  warning: warning.value,
                  class: "overflow-x-auto"
                }, null, 8, ["information", "warning"])
              ])
            ])
          ])
        ]),
        _createVNode(DataTabs, {
          headers: smallScreen.value ? tabHeadersShortened : tabHeaders,
          class: "mb-3 relative pt-1",
          expandedActive: 0,
          parentTabActive: 3
        }, {
          default: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Table, {
                "is-edit-mode": true,
                data: tableData.value[slotProps.index].length !== 0 ? tableData.value[slotProps.index].slice(tableOffset.value, tableOffset.value + __props.limit) : tableData.value[slotProps.index],
                columns: venueColumns[slotProps.index],
                onNextPage: _cache[4] || (_cache[4] = ($event: any) => {tableOffset.value = tableOffset.value + __props.limit;}),
                onRemoveItem: removeItem,
                onPrevPage: _cache[5] || (_cache[5] = ($event: any) => (tableOffset.value = tableOffset.value - __props.limit)),
                limit: __props.limit,
                offset: tableOffset.value,
                "total-count": tableData.value[slotProps.index].length,
                message: { title: 'No Entries', paragraph: 'No current data for this Venue' }
              }, null, 8, ["data", "columns", "limit", "offset", "total-count"])
            ])
          ]),
          _: 1
        }, 8, ["headers"]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => {confirmSave();}),
            class: "bg-[#1f2937] hover:bg-slate-500 text-white ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 rounded w-24 float-right flex items-center justify-center"
          }, " Save "),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => {confirmCancel();}),
            class: "border-[#1f2937] border-2 hover:bg-gray-200 text-[#1f2937] ml-2 mb-2 mt-0 font-semi h-6 py-0 pb-0.5 justify-center rounded w-24 float-right flex items-center"
          }, " Cancel ")
        ])
      ]))
}
}

})